<template>
  <InputDate
    :key="filtro.filtro"
    :text="text"
    :filtro="filtro"
    :campo="filtro"
    :intervalo-data="intervaloData"
    @aplicarFiltro="aplicarFiltro"
    @dateRangeSelected="onDateRangeSelected"
    @dateRangeCleared="onDateRangeCleared"
    @update:text="onUpdateText"
    :path="path"
  />
</template>
<script>
import InputDate from '../../components/InputDate.vue';
// Variante de DataPeriodo.vue usada pela listagem de cobrancas (admin/financeiro/cobrancas).
// Diferenca unica: emite params `<filtro>_inicio`/`<filtro>_fim` em vez de `<filtro>_ini`/`<filtro>_fim`,
// para casar com o contrato do ListagemCobrancasService (usa `:data_vencimento_inicio`).
// Nao alterar DataPeriodo.vue para nao quebrar as telas que ja usam o sufixo `_ini`.
export default {
  props: {
    filtro: {
      type: Object,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  components: {
    InputDate
  },
  data() {
    return {
      selectedDateRange: {
        inicio: '',
        fim: ''
      },
      text: ''
    };
  },
  computed: {
    intervaloData() {
      const filtros = this.$store.state.filtroAplicados;
      return {
        inicio: filtros[`${this.filtro.filtro}_inicio`] || '',
        fim: filtros[`${this.filtro.filtro}_fim`] || ''
      };
    }
  },
  watch: {
    intervaloData: {
      handler(newVal) {
        if (!newVal?.inicio || !newVal?.fim) return;

        const inicioMoment = moment(newVal.inicio, 'DD/MM/YYYY');
        const fimMoment = moment(newVal.fim, 'DD/MM/YYYY');

        if (!inicioMoment.isValid() || !fimMoment.isValid()) return;

        this.selectedDateRange = { inicio: newVal.inicio, fim: newVal.fim };
        this.text = this.formataTexto(newVal.inicio, newVal.fim);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    onDateRangeSelected(data) {
      this.selectedDateRange = data;
      this.text = this.formataTexto(data.inicio, data.fim);
      this.aplicarFiltro();
    },
    onDateRangeCleared() {
      this.selectedDateRange = { inicio: '', fim: '' };
      this.text = '';
      ['inicio', 'fim'].forEach(sufixo => {
        const filtro = `${this.filtro.filtro}_${sufixo}`;
        this.$removeFiltroDaURL(filtro, this.path);
        this.$store.commit('removeFiltroAplicado', filtro);
      });
    },
    aplicarFiltro() {
      if (!this.selectedDateRange.inicio || !this.selectedDateRange.fim) return;

      const datas = {
        inicio: this.selectedDateRange.inicio.replaceAll('-', '/'),
        fim: this.selectedDateRange.fim.replaceAll('-', '/')
      };

      ['inicio', 'fim'].forEach(sufixo => {
        const filtro = `${this.filtro.filtro}_${sufixo}`;
        const valor = datas[sufixo];
        this.$aplicaFiltroEmURL(filtro, valor, this.path);
        this.$store.commit('addFiltroAplicado', { filtro, valor });
      });
    },
    onUpdateText(text) {
      this.text = text;
    },
    formataTexto(inicio, fim) {
      const i = inicio.replaceAll('-', '/');
      const f = fim.replaceAll('-', '/');
      return i === f ? i : `${i} - ${f}`;
    }
  },
  mounted() {
    const filtros = this.$store.state.filtroAplicados;
    const inicio = filtros[`${this.filtro.filtro}_inicio`];
    const fim = filtros[`${this.filtro.filtro}_fim`];

    if (inicio && fim) {
      this.selectedDateRange = { inicio, fim };
      this.text = this.formataTexto(inicio, fim);
    } else if (Object.hasOwn(filtros, this.filtro.filtro)) {
      this.text = filtros[this.filtro.filtro];
    } else {
      // Nenhuma acao necessaria se nenhum filtro de data esta aplicado.
    }
  },
  beforeUnmount() {
    this.selectedDateRange = { inicio: '', fim: '' };
    this.text = '';
  }
}
</script>
